__turbopack_context__.v({
  "listingIconBox": "listing-icon-box-module-scss-module__bxxlrq__listingIconBox",
  "listingIconBox_imageWrapper": "listing-icon-box-module-scss-module__bxxlrq__listingIconBox_imageWrapper",
  "listingIconBox_name": "listing-icon-box-module-scss-module__bxxlrq__listingIconBox_name",
});
